import React, { useEffect, useState } from 'react'
import './Home.css'
import OrgChart from '../component/OrgChart';
import axios from 'axios';
import Navbar from '../component/Navbar';

const KejatiHome = () => {

    const url = window.location.origin;
    const parsedUrl = new URL(url);
    const domain = parsedUrl.hostname;

    const [loading, setLoading] = useState(true);
    const [appLogo, setAppLogo] = useState(`/assets/icon_network.png`);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const URL_GET_PROJECT = `${process.env.REACT_APP_API_BASE_URL}api/system/home?domain=${domain}`;

    const [orgData] = useState([
        {
            title: "Kepala Kejaksaan Tinggi Daerah Khusus Jakarta",
            name: "Dr. Patris Yusrian Jaya",
            photo: "/assets/kejati/person/photo-kajati.png",
            jobdesc: "",
            color: "",
            children: [
                {
                    title: "Wakil Kepala Kejaksaan Tinggi Daerah Khusus Jakarta",
                    name: "DANANG SURYO WIBOWO, S.H., LL.M.",
                    photo: "/assets/kejati/person/photo-wakajati.png",
                    children: [
                        {
                            title: "Asisten Pembinaan",
                            name: "LAKSMI INDRIYAH R., S.H., LL.M.",
                            photo: "/assets/kejati/person/photo-asisten-pembinaan.png",
                            jobdesc: "Memiliki peran menjalankan tugas & fungsi administrasi perkantoran",
                            color: "#ffd800"
                        },
                        {
                            title: "Asisten Intelijen",
                            name: "ASEP SONTANI SUNARYA, S.H., CN.",
                            photo: "/assets/kejati/person/Asintel.png",
                            jobdesc: "Melakukan kegiatan intelijen yustisial di bidang ideologi, politik, ekonomi, keuangan, sosial budaya dan pertahanan keamanan untuk mendukung bantuan penegakan hkum dan keadilan baik preventif maupun represif",
                            color: "#05b339"
                        },
                        {
                            title: "Asisten Tindak Pidana Umum",
                            name: "ANDI SUHARLIS, S.H., M.H.",
                            photo: "/assets/kejati/person/Aspidum.png",
                            jobdesc: "Memiliki peran dalam menjalankan tugas & fungsi pelaksanaan dan pengendalian kegiatan prapenuntutan, penuntutan dalam perkara tindak pidana umum",
                            color: "#de1414"
                        },
                        {
                            title: "Asisten Tindak Pidana Khusus",
                            name: "SYARIEF SULAEMAN NAHDI, S.H., M.H.",
                            photo: "/assets/kejati/person/Aspidsus.png",
                            jobdesc: "Memiliki peran melakukan penyidikan, pra penuntutan, pemeriksaan tambahan, penuntutan, pelaksanaan hukuman hakim, putusan pengadilan yang telah mempunyai kekuatan hukum tetap terkait tindak pidana khusus",
                            color: "#d755d5"
                        },
                        {
                            title: "Asisten Perdata dan Tata Usaha Negara",
                            name: "BADRUT TAMAM, S.H., M.H.",
                            photo: "/assets/kejati/person/Asdatun.png",
                            jobdesc: "Mempunyai tugas melakukan dan atau pengendalian kegiatan penegakan, bantuan, pertimbangan dan pelayanan hukum serta tindakan hukum lain kepada negara, pemerintah dan masyarakat di Bidang Perdata dan Tata Usaha Negara.",
                            color: "#ffbf59"
                        },
                        {
                            title: "Asisten Pengawasan",
                            name: "TJAKRA SUYANA EKA PUTRA, S.H., M.H.",
                            photo: "/assets/kejati/person/Aswas.png",
                            jobdesc: "Melaksanakan pengawasan di lingkungan Kejaksaan terhadap pelaksanaan tugas semua unsur Kejaksaan agar dapat berjalan sesuai dengan rencana dan kebijaksanaan yang ditetapkan oleh Jaksa Agung",
                            color: "#0223c7"
                        },
                        {
                            title: "Asisten Pidana Militer",
                            name: "Dra. AINUR ROCHMAINI, S.H., M.H.",
                            photo: "/assets/kejati/person/Aspidmil.png",
                            jobdesc: "memiliki tugas dan wewenang khusus untuk penanganan Perkara Koneksitas. Perkara Koneksitas sendiri merupakan perkara yang pelakukanya terdiri dari 2 (dua) komponen yaitu sipil dan militer, yang dalam istilah lain yaitu tindak pidana yang dilakukan bersama-sama oleh mereka yang termasuk juridiksi peradilan umum dan peradilan militer",
                            color: "#196d10"
                        },
                    ],
                },
            ],
        },
    ]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response;
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(URL_GET_PROJECT).then((value) => {
            setAppLogo(`${BASE_URL}upload/logo/${value.data.logo}`)
        });
    }, [domain]);


    if (loading) {
        return <div>Loading...</div>;
    }

    const overlayStyle = {
        position: 'absolute',           // Absolutely position the overlay on top of the background
        top: '150px',
        left: 0,
        right: 0,
        bottom: '150px',
        backgroundImage: `url(${appLogo})`,  // Dynamically use the appLogo as the background image
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        opacity: 0.1,                   // Set opacity for transparency (0 is fully transparent, 1 is opaque)
        pointerEvents: 'none',
    };

    return (
        <div >
            <div style={overlayStyle}></div>
            <Navbar appLogo={appLogo} toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
            <div className="home">
                <h1>Struktur Organisasi Kejaksaan Tinggi</h1>
                <OrgChart data={orgData} />
            </div>
        </div>
    )
}

export default KejatiHome;
